import { render } from "./support-page.vue?vue&type=template&id=0384c70a&scoped=true&ts=true"
import script from "./support-page.vue?vue&type=script&lang=ts"
export * from "./support-page.vue?vue&type=script&lang=ts"

import "./support-page.vue?vue&type=style&index=0&id=0384c70a&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0384c70a"]])

export default __exports__